var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1686550876(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4 20.0656C59.3823 20.0656 61.8 17.6875 61.8 14.7541C61.8 11.8206 59.3823 9.44262 56.4 9.44262C53.4177 9.44262 51 11.8206 51 14.7541C51 17.6875 53.4177 20.0656 56.4 20.0656Z",
    fill: "#7F265B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2003 20.0656C19.1826 20.0656 21.6003 17.6875 21.6003 14.7541C21.6003 11.8206 19.1826 9.44262 16.2003 9.44262C13.218 9.44262 10.8003 11.8206 10.8003 14.7541C10.8003 17.6875 13.218 20.0656 16.2003 20.0656Z",
    fill: "#7F265B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2003 62.5574C19.1826 62.5574 21.6003 60.1793 21.6003 57.2459C21.6003 54.3125 19.1826 51.9344 16.2003 51.9344C13.218 51.9344 10.8003 54.3125 10.8003 57.2459C10.8003 60.1793 13.218 62.5574 16.2003 62.5574Z",
    fill: "#7F265B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4 62.5574C59.3823 62.5574 61.8 60.1793 61.8 57.2459C61.8 54.3125 59.3823 51.9344 56.4 51.9344C53.4177 51.9344 51 54.3125 51 57.2459C51 60.1793 53.4177 62.5574 56.4 62.5574Z",
    fill: "#7F265B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32.459,
    width: 72,
    height: 7.08197,
    rx: 3.54098,
    fill: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6001,
    y: 42.4918,
    width: 29.5082,
    height: 7.2,
    rx: 3.6,
    transform: "rotate(90 39.6001 42.4918)",
    fill: "#555555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6001,
    width: 29.5082,
    height: 7.2,
    rx: 3.6,
    transform: "rotate(90 39.6001 0)",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1686550876);
export default __webpack_public_path__ + "static/media/Group 1686550876.535450e9c2ebbf2ece1f606e322131b1.svg";
export { ForwardRef as ReactComponent };